// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-right-buttons-container {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 2;
  display: flex;
  flex-direction: row;
}
.top-right-buttons-container .button-container {
  position: relative;
}
.top-right-buttons-container .button-container .btn-img::part(image) {
  width: 2.667rem;
  height: 2.667rem;
  cursor: pointer;
}
.top-right-buttons-container .button-container .btn-img-break::part(image) {
  width: 4rem;
  height: 2.667rem;
  margin-right: 0.1rem;
  cursor: pointer;
}
.top-right-buttons-container .button-container .btn-icon {
  font-size: 1.333rem;
  position: absolute;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.top-right-buttons-container .button-container .mute {
  font-size: 1.633rem;
  top: 0.433rem;
  left: 0.533rem;
}
.top-right-buttons-container .button-container .settings {
  top: 0.584rem;
  left: 0.688rem;
}
.top-right-buttons-container .button-container .red-white-arrow .red-white-arrow-icon {
  position: absolute;
  left: 1.8rem;
  top: 2.8rem;
  width: 1.5rem;
  transform: rotateX(175deg) rotate(95deg);
  --animate-duration: 3s;
}
.top-right-buttons-container .button-container .text {
  color: var(--color-yellow-bookmark);
  width: 10.708rem;
  font-size: 1rem;
  line-height: 1rem;
  text-align: center;
  position: absolute;
  left: 1.5rem;
  top: 3.5rem;
}
.top-right-buttons-container > div:not(:last-child) {
  margin-right: 0.333rem;
}

.check-here {
  position: absolute;
  top: 3rem;
  right: 8.5rem;
  padding: 1rem;
}
.check-here .text {
  color: white;
  width: 10.708rem;
  font-size: 0.833rem;
  line-height: 1rem;
  text-align: center;
  position: absolute;
  right: -4rem;
  top: 2.5rem;
}
.check-here .white-arrow .white-arrow-icon {
  position: absolute;
  left: 6rem;
  width: 2rem;
  height: 3.333rem;
  transform: rotate(250deg);
  --animate-duration: 1s;
}

.oval {
  position: absolute;
  top: 0.24rem;
  right: 0.3rem;
  z-index: 15;
  cursor: pointer;
}
.oval img {
  width: 4rem;
  height: 4rem;
}

.help-modal-container {
  display: flex;
  position: absolute;
  background: #f5db6c;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  border: 0.1rem solid #d1af1f;
  opacity: 0.95;
  border-radius: 0.8rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  max-width: 14rem;
  height: fit-content;
  z-index: 10;
}

.btn-group-light {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
}
.btn-group-light button {
  background-color: transparent;
  border: 0.1rem solid var(--color-primary-blue);
  border-radius: 1.2rem;
  color: var(--color-primary-blue);
  padding: 0.5rem 3rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.1rem;
  cursor: pointer;
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.flex-row {
  display: flex;
  min-width: -webkit-fill-available;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  justify-content: space-around;
}

.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pagination {
  justify-self: end;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #564547;
  margin-left: 0.5rem;
  margin-right: 1rem;
  font-weight: 500;
}

.text-title {
  align-self: flex-start;
  font-size: 1.2rem;
  color: var(--color-primary-blue);
  font-weight: 500;
  line-height: 1.2rem;
  margin-left: 1rem;
}

ion-toggle::part(track) {
  height: 1rem;
  width: 2.4rem;
  overflow: visible;
  contain: none;
}

ion-toggle {
  --handle-height: 1rem;
  --handle-width: 1rem;
  --handle-max-height: auto;
  --handle-border-radius: 0.5rem;
  --handle-box-shadow: none;
  z-index: 15;
}

.active-toggle {
  --handle-background: var(--color-yellow-bookmark);
}

.text {
  overflow-wrap: break-word;
  font-size: 0.8rem;
  line-height: 1rem;
  font-weight: 400;
  padding-inline: 1.1rem;
}
.text .part1 {
  color: #564547;
  margin-bottom: 0.5rem;
}
.text .part2 {
  color: var(--color-primary-blue);
  margin-bottom: 0.7rem;
}

.toggle-label {
  line-height: 0.3rem;
  color: aliceblue;
  margin-top: 0.5rem;
}

.text-break {
  padding-inline: 0.8rem;
  font-size: 0.8rem;
  color: var(--color-primary-blue);
}`, "",{"version":3,"sources":["webpack://./src/app/components/setting-help/setting-help.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AACN;AAEI;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAAN;AAGI;EACE,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AADN;AAII;EACE,mBAAA;EACA,aAAA;EACA,cAAA;AAFN;AAKI;EACE,aAAA;EACA,cAAA;AAHN;AAOM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;EACA,sBAAA;AALR;AASI;EACE,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAPN;AAWE;EACE,sBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;AAVF;AAYE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAVJ;AAcI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAZN;;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAdF;AAeE;EACE,WAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oGAAA;EAKA,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,6BAAA;EACA,8CAAA;EACA,qBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAlBJ;;AAqBA;EACE,aAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,sBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,oBAAA;EACA,yBAAA;EAEA,8BAAA;EACA,yBAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,iDAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAlBF;AAoBE;EACE,cAAA;EACA,qBAAA;AAlBJ;AAoBE;EACE,gCAAA;EACA,qBAAA;AAlBJ;;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,sBAAA;EACA,iBAAA;EACA,gCAAA;AAnBF","sourcesContent":[".top-right-buttons-container {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n\n  .button-container {\n    position: relative;\n\n    .btn-img::part(image) {\n      width: 2.667rem;\n      height: 2.667rem;\n      cursor: pointer;\n    }\n\n    .btn-img-break::part(image) {\n      width: 4rem;\n      height: 2.667rem;\n      margin-right: 0.1rem;\n      cursor: pointer;\n    }\n\n    .btn-icon {\n      font-size: 1.333rem;\n      position: absolute;\n      color: var(--color-primary-blue);\n      cursor: pointer;\n    }\n\n    .mute {\n      font-size: 1.633rem;\n      top: 0.433rem;\n      left: 0.533rem;\n    }\n\n    .settings {\n      top: 0.584rem;\n      left: 0.688rem;\n    }\n\n    .red-white-arrow {\n      .red-white-arrow-icon {\n        position: absolute;\n        left: 1.8rem;\n        top: 2.8rem;\n        width: 1.5rem;\n        transform: rotateX(175deg) rotate(95deg);\n        --animate-duration: 3s;\n      }\n    }\n\n    .text {\n      color: var(--color-yellow-bookmark);\n      width: 10.708rem;\n      font-size: 1rem;\n      line-height: 1rem;\n      text-align: center;\n      position: absolute;\n      left: 1.5rem;\n      top: 3.5rem;\n    }\n  }\n\n  & > div:not(:last-child) {\n    margin-right: 0.333rem;\n  }\n}\n\n.check-here {\n  position: absolute;\n  top: 3rem;\n  right: 8.5rem;\n  padding: 1rem;\n\n  .text {\n    color: white;\n    width: 10.708rem;\n    font-size: 0.833rem;\n    line-height: 1rem;\n    text-align: center;\n    position: absolute;\n    right: -4rem;\n    top: 2.5rem;\n  }\n\n  .white-arrow {\n    .white-arrow-icon {\n      position: absolute;\n      left: 6rem;\n      width: 2rem;\n      height: 3.333rem;\n      transform: rotate(250deg);\n      --animate-duration: 1s;\n    }\n  }\n}\n\n.oval {\n  position: absolute;\n  top: 0.24rem;\n  right: 0.3rem;\n  z-index: 15;\n  cursor: pointer;\n  img {\n    width: 4rem;\n    height: 4rem;\n  }\n}\n\n.help-modal-container {\n  display: flex;\n  position: absolute;\n  background: #f5db6c;\n  background-image: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.48) 100%\n  );\n  border: 0.1rem solid #d1af1f;\n  opacity: 0.95;\n  border-radius: 0.8rem;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: fit-content;\n  max-width: 14rem;\n  height: fit-content;\n  z-index: 10;\n}\n\n.btn-group-light {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  align-items: center;\n\n  button {\n    background-color: transparent;\n    border: 0.1rem solid var(--color-primary-blue);\n    border-radius: 1.2rem;\n    color: var(--color-primary-blue);\n    padding: 0.5rem 3rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 1.1rem;\n    cursor: pointer;\n    margin-top: 0.2rem;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n  }\n}\n.flex-row {\n  display: flex;\n  min-width: -webkit-fill-available;\n  margin-bottom: 0.8rem;\n  margin-top: 0.8rem;\n  justify-content: space-around;\n}\n.flex-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination {\n  justify-self: end;\n  font-size: 0.8rem;\n  line-height: 1rem;\n  color: #564547;\n  margin-left: 0.5rem;\n  margin-right: 1rem;\n  font-weight: 500;\n}\n\n.text-title {\n  align-self: flex-start;\n  font-size: 1.2rem;\n  color: var(--color-primary-blue);\n  font-weight: 500;\n  line-height: 1.2rem;\n  margin-left: 1rem;\n}\n\nion-toggle::part(track) {\n  height: 1rem;\n  width: 2.4rem;\n  overflow: visible;\n  contain: none;\n}\n\nion-toggle {\n  --handle-height: 1rem;\n  --handle-width: 1rem;\n  --handle-max-height: auto;\n\n  --handle-border-radius: 0.5rem;\n  --handle-box-shadow: none;\n  z-index: 15;\n}\n\n.active-toggle {\n  --handle-background: var(--color-yellow-bookmark);\n}\n\n.text {\n  overflow-wrap: break-word;\n  font-size: 0.8rem;\n  line-height: 1rem;\n  font-weight: 400;\n  padding-inline: 1.1rem;\n\n  & .part1 {\n    color: #564547;\n    margin-bottom: 0.5rem;\n  }\n  & .part2 {\n    color: var(--color-primary-blue);\n    margin-bottom: 0.7rem;\n  }\n}\n\n.toggle-label {\n  line-height: 0.3rem;\n  color: aliceblue;\n  margin-top: 0.5rem;\n}\n\n.text-break {\n  padding-inline: 0.8rem;\n  font-size: 0.8rem;\n  color: var(--color-primary-blue);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
